import { render } from "./DocumentClassTablesSubView.vue?vue&type=template&id=f4ba9ae6&scoped=true&ts=true"
import script from "./DocumentClassTablesSubView.vue?vue&type=script&lang=ts"
export * from "./DocumentClassTablesSubView.vue?vue&type=script&lang=ts"

import "./DocumentClassTablesSubView.vue?vue&type=style&index=0&id=f4ba9ae6&scoped=true&lang=css"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4ba9ae6"]])

export default __exports__